import { TripleDirection } from '@ardoq/api-types';
import { MetadataComponent, PathCollapsingRuleInternal } from '../types';
import type { CollapsingRuleErrorCode } from './CollapsingRuleErrorMessage';

export type EditablePathCollapsingRule = PathCollapsingRuleInternal & {
  startNodeId: string | null;
  errorMessage: CollapsingRuleErrorCode | null;
};

export type ViewStateEditablePathCollapsingRule = EditablePathCollapsingRule & {
  startNode: MetadataComponent | null;
  endNode: MetadataComponent | null;
  isSavable: boolean;
  /**
   * The hierarchy levels the rule keeps expanded, or `null` when the rule does
   * not collapse a hierarchy at all and the field does not apply.
   */
  keepExpandedLevels: number | null;
};

export const isSavedPathCollapsingRule = (
  rule: ViewStatePathCollapsingRule
): rule is SavedViewStatePathCollapsingRule =>
  'collapsedPath' in rule && rule.collapsedPath !== null;

export type SavedViewStatePathCollapsingRule = {
  referenceTypeId: string;
  collapsedPath: {
    direction: TripleDirection;
    referenceType: string;
    componentTypeMetaData: MetadataComponent;
  }[];
  startNode: MetadataComponent | null;
  endNode: MetadataComponent | null;
  displayText: string;
  isExpanded: boolean;
  isActive: boolean;
};

type UnsavedViewStatePathCollapsingRule = {
  referenceTypeId: string;
};

export type ViewStatePathCollapsingRule =
  | UnsavedViewStatePathCollapsingRule
  | SavedViewStatePathCollapsingRule;

export type PathCollapsingViewState = {
  currentEditableRule: ViewStateEditablePathCollapsingRule | null;
  rules: ViewStatePathCollapsingRule[];
};
